//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"BuildStatus",0,0],[0,"Center",1,"ILocation",0],[0,"Clearance",1,0],[0,"CoreOrientation",1,"ISurface",0],[0,"Depth",1,0],[0,"DesignStatus",1,0],[0,"DisplayStatus",1,0],[0,"Height",1,0],[0,"ReverseOrientation",1,0],[0,"Width",1,0]],[[["translate_dist"],"TranslateCenter",{},1,0]],[]];
SPLM.Die.HandlingCoreChildBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.HandlingCoreChildBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;